/**
 * Wi-Fi network table row action buttons (WifiSettingsPanel).
 * Fixed height so Connect / Disconnect match; title uses !important to override
 * FunctionalButton’s default `capitalize` / line-height quirks.
 */
const networkRowShell =
    "h-8 min-h-8 shrink-0 rounded-r5 border px-2.5 disabled:opacity-50";

export const NETWORK_ROW_CONNECT_BUTTON_CLASS = `${networkRowShell} border-black80 bg-black70 hover:bg-black80`;

export const NETWORK_ROW_CONNECT_TITLE_CLASS =
    "!normal-case !text-h5 !leading-none !font-normal";

export const NETWORK_ROW_DISCONNECT_BUTTON_CLASS = `${networkRowShell} border-red-900/80 bg-black70 hover:bg-black80`;

export const NETWORK_ROW_DISCONNECT_TITLE_CLASS =
    "!normal-case !text-h5 !leading-none !font-normal !text-red-400";

/** Ethernet settings: primary green connect (header + history). */
export const ETHERNET_CONNECT_GREEN_BUTTON_CLASS = `${networkRowShell} border-primary2 bg-primary2 hover:bg-primary1`;

export const ETHERNET_CONNECT_GREEN_TITLE_CLASS =
    "!normal-case !text-h5 !leading-none !font-normal !text-white";
